











import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { classTerm } from "../core/types";

@Component({
    name: "terms-list",
    components: {},
})
export default class TermsList extends Vue {
    @Prop() term!: classTerm;
    @Prop() terms!: classTerm[];
    @Prop() rootTerm!: string;
    @Prop({ default: true }) expandable!: boolean;
    @Prop({ default: true }) showClass!: boolean;
}
